import { TaskMode } from 'Types/Tasks.types'
import { DecisionStatusType } from 'Types/Tasks.types'
import { ActionConfig, ActionContext, IAction } from '../Action'

export class FinishQCAction implements IAction {
    static Id = 'FinishQC' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench(): void {
        this.actionContext.workbenchUiAccessor.toolbar.addAction(
            {
                id: 'finish-qc',
                title: this.config?.title ?? 'Finish QC',
                type: 'button',
                color: 'primary',
                disabled: this.config?.disabled ?? false,
                children: this.config?.children ?? [
                    {
                        id: 'edit',
                        title: 'Edit Response',
                        onClick: () => {
                            this.actionContext.task.taskState.setDecision({
                                status: DecisionStatusType.ACCEPT,
                                schema_version: 1,
                            })
                            this.actionContext.modalManager?.showModal('action-modal')
                            this.actionContext.task.ui?.updater.forceUpdate()
                            this.actionContext.task.updateAttributesUI()
                        },
                    },
                    {
                        id: 'submit',
                        title: 'Submit Response',
                        onClick: () => {
                            const errors =
                                this.actionContext.studio.inputManager.getViolationCount('error')
                            if (errors) {
                                this.actionContext.modalManager?.showModal('violations-modal')
                                this.actionContext.task.ui?.updater.forceUpdate()
                                return
                            }

                            this.actionContext.task.taskState.setDecision({
                                status: DecisionStatusType.ACCEPT,
                                schema_version: 1,
                            })
                            this.actionContext.modalManager?.setModalMetaData('submit-modal', {
                                taskMode: TaskMode.QC,
                                isAccept: true,
                            })
                            this.actionContext.modalManager?.showModal('submit-modal')
                        },
                    },
                ],
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor?.toolbar.removeAction('finish-qc')
    }
}
